module.exports = __webpack_public_path__ + "static/media/logo.e825be20.png";